<template>
	<div v-if="job" class="md-layout" id="top">
		<div class="md-layout-item md-size-66 md-xsmall-size-80 mx-auto">
			<application-simple-wizard :job="job">
				<template slot="header">
					<h3 class="title">{{ job.name }}</h3>

					<div v-if="job" class="flex items-center justify-center">
						<h4 style="margin-right: 2rem">🏢 {{ job.companyName }}</h4>
						<h4 style="margin-right: 2rem">📅 {{ job.applicationDeadline }}</h4>
						<h4>📅 {{ application.applicationStatus }}</h4>
					</div>
					<md-button style="position: absolute; top: 3px; left: 10px; font-size: 30px !important" class="md-simple md-just-icon md-round modal-default-button">
						<md-icon>help</md-icon>
					</md-button>
				</template>
				<wizard-tab :before-change="() => validateStep('step1')">
					<template slot="label">
						<div class="pc-view">Job Details</div>
						<div class="mobi-view"><i class="fas fa-location-arrow"></i></div>
					</template>
					<job-application-details :job="job" :skills="skills" :micro="micro"></job-application-details>
				</wizard-tab>
				<wizard-tab :before-change="() => validateStep('step2')">
					<template slot="label">
						<div class="pc-view">Documents</div>
						<div class="mobi-view"><i class="fas fa-location-arrow"></i></div>
					</template>
					<job-application-documents :job="job" :micro="micro" :application="application" :user="user"></job-application-documents>
				</wizard-tab>
				<wizard-tab :before-change="() => validateStep('step3')">
					<template slot="label">
						<div class="pc-view">Offer Details</div>
						<div class="mobi-view"><i class="fas fa-location-arrow"></i></div>
					</template>
					<job-application-offers :job="job" :micro="micro" :application="application" :user="user"></job-application-offers>
				</wizard-tab>
			</application-simple-wizard>
		</div>
	</div>
</template>
<script>
import { WizardTab } from '@/components';
import ApplicationSimpleWizard from './wizard/Wizard.vue';
import JobApplicationDetails from './wizard/formSteps/JobApplicationDetails.vue';
import JobApplicationDocuments from './wizard/formSteps/JobApplicationDocuments.vue';
import JobApplicationOffers from './wizard/formSteps/JobApplicationOffers.vue';
import moment from 'moment';
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '@/firebase/init';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

export default {
	components: {
		ApplicationSimpleWizard,
		WizardTab,
		JobApplicationDetails,
		JobApplicationDocuments,
		JobApplicationOffers,
	},
	data() {
		return {
			jobId: null,
			job: null,
			micro: null,
			application: null,
			loadingJob: true,
			loadingApplication: true,
			hasApplied: false,
			user: null,
			skills: null,
			skillsList: [],
		};
	},
	methods: {
		async fetchJobDocument(jobId) {
			const jobRef = doc(db, 'jobs', jobId);
			const jobSnap = await getDoc(jobRef);

			if (jobSnap.exists()) {
				this.job = jobSnap.data();
				if (this.job.applicationDeadline) {
					this.job.applicationDeadline = moment(this.job.applicationDeadline).format('LL');
				} else {
					this.job.applicationDeadline = 'No deadline specified';
				}

				const querySnapshot = await getDocs(query(collection(db, 'jobs', jobSnap.id, 'offers'), where('userId', '==', this.user.alias)));
				if (!querySnapshot.empty) {
					querySnapshot.forEach(doc => {
						this.job.offer = { id: doc.id, ...doc.data() };
					});
				}
			}

			const microRef = doc(db, 'micros', jobId);
			const microsSnap = await getDoc(microRef);
			if (microsSnap.exists()) {
				this.micro = microsSnap.data();
			}

			const skillsRef = doc(db, 'skills', jobId);
			const skillsSnap = await getDoc(skillsRef);

			if (skillsSnap.exists()) {
				this.skills = skillsSnap.data();
				this.skillsList = this.skills.skills.filter(skill => skill.skillName);
			} else {
				console.log('No such document!');
			}
		},
		async fetchApplicationDocument(jobId) {
			try {
				const user = firebase.auth().currentUser;
				const applicationCollection = collection(db, 'applications');
				const applicationsQuery = query(applicationCollection, where('jobId', '==', jobId), where('studentId', '==', user.uid));
				const querySnapshot = await getDocs(applicationsQuery);

				if (!querySnapshot.empty) {
					const docSnap = querySnapshot.docs[0];
					this.application = { id: docSnap.id, ...docSnap.data() };
				} else {
					this.application = null;
				}
			} catch (error) {
				console.error('Error fetching application:', error);
			}
		},
		async fetchUser() {
			try {
				const q = query(collection(db, 'users'), where('userId', '==', firebase.auth().currentUser.uid));
				const querySnapshot = await getDocs(q);

				querySnapshot.forEach(doc => {
					this.user = doc.data();
				});
			} catch (error) {
				console.error('Error fetching user alias:', error);
				return null;
			}
		},
	},
	async mounted() {
		this.jobId = this.$route.params.id;
		await this.fetchUser();
		await this.fetchApplicationDocument(this.jobId);
		await this.fetchJobDocument(this.jobId);
	},
};
</script>
